import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';

export default {
  schema: {
    fields: [
      {
        type: 'radios',
        label: 'What is the current occupancy status of the Main Property?',
        model: 'property.status',
        required: true,
        styleClasses: 'col-md-12 flex-radio',
        values: [
          { name: 'Vacant', value: 'vacant' },
          { name: 'Vacant at Close', value: 'vacant at close' },
          { name: 'Occupied', value: 'occupied' },
        ],
        validator: VueFormGenerator.validators.required,
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            model.property.closingStatus = null;
          } catch (_) {
            // If model is not loaded, don't bother
          }
        },
      },
      {
        type: 'radios',
        label: 'At the closing, what will the occupancy status of the Main Property be?',
        model: 'property.closingStatus',
        required: true,
        styleClasses: 'col-md-12 flex-radio',
        values: [
          { name: 'Definitely Vacant', value: 'definitely_vacant' },
          { name: 'Likely to be Vacant', value: 'likely_vacant' },
          { name: 'Remain Occupied', value: 'remain_occupied' },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          try {
            return model.property.status === 'occupied';
          } catch (_) {
            return false;
          }
        },
      },
      /* -------------- Contact Information Fields --------------*/
      {
        type: 'input',
        label: 'Who is the Point of Contact for Property Access?',
        inputType: 'text',
        model: 'property.contact.name',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Contact Name',
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        disabled() {
          return this.model.property.visit.type === 'appointment';
        },
      },
      {
        type: 'cleave',
        model: 'property.contact.phone',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Contact Cell Phone',
        required: true,
        styleClasses: 'col-md-12',
        cleaveOptions: {
          numericOnly: true,
          blocks: [0, 3, 3, 4],
          delimiters: ['(', ') ', '-'],
        },
        pattern: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/g,
        validator: VueFormGenerator.validators.regexp,
        disabled() {
          return this.model.property.visit.type === 'appointment';
        },
      },
      {
        type: 'textArea',
        model: 'property.contact.notes',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Notes',
        rows: 3,
        required: false,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        disabled() {
          return this.model.property.visit.type === 'appointment';
        },
      },
      /* -------------- End of Contact Information Fields --------------*/
      {
        type: 'radios',
        label: 'If we want to send an inspector out to visit the property, how do they gain access?',
        model: 'property.visit.type',
        required: true,
        styleClasses: 'col-md-12',
        values: [
          { name: 'Lock Box', value: 'lock_box' },
          { name: 'Supra', value: 'supra' },
          { name: 'Appointment Only', value: 'appointment' },
          { name: 'Other', value: 'other' },
        ],
        validator: VueFormGenerator.validators.required,
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            ['lockBox', 'supra', 'appointment', 'other'].forEach((type) => {
              Vue.delete(model.property.visit, type);
            });

            model.property.visit.appointment = {};
            model.property.visit.appointment.phone = model.property.contact.phone;
            model.property.visit.appointment.name = model.property.contact.name;

            if (model.property.visit.type === 'appointment') {
              model.property.visit.appointment.notes = model.property.contact.notes;
            }
          } catch (_) {
            // If model is not loaded, don't bother
          }
        },
      },
      /* ----------------------------------- Lock Box Fields ------------------------------------*/
      {
        type: 'input',
        inputType: 'text',
        model: 'property.visit.lockBox.code',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Code',
        required: true,
        styleClasses: 'col-md-6',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'lock_box';
          } catch (_) {
            return false;
          }
        },
      },
      {
        type: 'input',
        inputType: 'text',
        model: 'property.visit.lockBox.location',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Location',
        required: true,
        styleClasses: 'col-md-6',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'lock_box';
          } catch (_) {
            return false;
          }
        },
      },
      {
        type: 'textArea',
        model: 'property.visit.lockBox.notes',
        placeholder: 'Notes',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        rows: 3,
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'lock_box';
          } catch (_) {
            return false;
          }
        },
      },
      /* ------------------------------- End of Lock Box Fields ---------------------------------*/
      /* ------------------------------------- Supra Fields -------------------------------------*/
      {
        type: 'input',
        inputType: 'text',
        model: 'property.visit.supra.location',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Location',
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'supra';
          } catch (_) {
            return false;
          }
        },
      },
      {
        type: 'textArea',
        model: 'property.visit.supra.notes',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Notes',
        rows: 3,
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'supra';
          } catch (_) {
            return false;
          }
        },
      },
      /* ----------------------------------- End of Supra Fields ---------------------------------*/
      /* ----------------------------------- Appointment Fields ----------------------------------*/
      {
        type: 'input',
        inputType: 'text',
        model: 'property.visit.appointment.name',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Contact Name',
        required: true,
        styleClasses: 'col-md-6',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'appointment';
          } catch (_) {
            return false;
          }
        },
      },
      {
        type: 'cleave',
        model: 'property.visit.appointment.phone',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Contact Cell Phone',
        required: true,
        styleClasses: 'col-md-6',
        cleaveOptions: {
          numericOnly: true,
          blocks: [0, 3, 3, 4],
          delimiters: ['(', ') ', '-'],
        },
        pattern: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/g,
        validator: VueFormGenerator.validators.regexp,
        visible(model) {
          try {
            return model.property.visit.type === 'appointment';
          } catch (_) {
            return false;
          }
        },
      },
      {
        type: 'textArea',
        model: 'property.visit.appointment.notes',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Notes',
        rows: 3,
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'appointment';
          } catch (_) {
            return false;
          }
        },
      },
      /* ------------------------------ End of Appointment Fields -------------------------------*/
      /* ------------------------------------- Other Fields -------------------------------------*/
      {
        type: 'textArea',
        model: 'property.visit.other.notes',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        placeholder: 'Notes',
        rows: 3,
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.property.visit.type === 'other';
          } catch (_) {
            return false;
          }
        },
      },
      /* ------------------------------- End of Other Fields ------------------------------------*/
      {
        type: 'currency',
        model: 'property.hoaFees',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        label: 'What are the HOA fees?',
        required: true,
        styleClasses: 'col-md-12',
        validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
        visible(model) {
          try {
            return model.propertyType.name === 'condo';
          } catch (_) {
            return false;
          }
        },
      },
    ],
  },
  formOptions: {
    validationErrorClass: 'invalid-input',
    validateAfterChanged: true,
    fieldIdPrefix: 'property-',
  },
};



// WEBPACK FOOTER //
// ./src/components/new_deal/components/property/schema.js